module.exports = __webpack_public_path__ + "2045e760e0e2ddca2e5975b6b3018e5a.png";